<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- Entête de l'interface de conversation -->
  <chatHeader />
  <main ref="pageContainer"
    class="m-0 mt-[-1rem] sm:w-[70vw] sm:mx-auto xl: w-full overflow-hidden md:w-[65vw] xl:w-[60vw] 2xl:w-[59vw] md:mx-auto lg:mx-auto">
    <!-- Interface de discussion -->
    <div class="p-3 mb-[10rem] md:mr-[2%] lg:mr-[5%] 2xl:mr-[6%]">
      <div class="">
        <!-- partie pour la gestion du fil de discussion -->
        <section v-for="(message, index) in chatHistory" :key="index" class="flex flex-col gap-3 mb-3">
          <!-- partie affichant les messages du bot -->
          <section v-if="message.role == 'bot'" class="flex flex-col gap-3">
            <!-- affiche les phrases d'introduction du bot -->
            <div v-show="message.welcomeMsg.length > 0" class="flex flex-col gap-3">
              <div class="flex items-center gap-6" v-for="(value, index) in message.welcomeMsg" :key="index">
                <p class="w-8 h-8 lg:w-10 lg:h-10 shrink-0 opacity-0"></p>
                <p
                  class="chat-bubble w-[80vw] sm:w-[58vw] md:w-[54vw] xl:w-[51vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base">
                  {{ value }}
                </p>
              </div>
            </div>
            <!-- affiche les affirmations -->
            <div v-if="message.affirmation.length > 0" class="flex flex-col gap-3">
              <div class="flex items-center gap-6" v-for="(value, index) in message.affirmation" :key="index">
                <p class="w-8 h-8 lg:w-10 lg:h-10 shrink-0 opacity-0"></p>
                <p
                  class="chat-bubble w-[80vw] sm:w-[58vw] md:w-[54vw] xl:w-[51vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base">
                  {{ value }}
                </p>
              </div>
            </div>
            <!-- affiche la question -->
            <div v-if="message.question" class="flex items-center gap-6">
              <img class="w-8 h-8 lg:w-10 lg:h-10 object-cover shrink-0 m-0" src="../assets/leo.png" alt="Léo">
              <p
                class="chat-bubble w-[80vw] sm:w-[58vw] md:w-[54vw] xl:w-[51vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base">
                {{ message.question }}
              </p>
            </div>
          </section>
          <!-- partie affichant les messages de l'utilisateur -->
          <section v-else class="flex justify-end w-full">
            <div
              class="chat-bubble_answer text-white p-2 px-4 text-[0.75rem] md:text-[0.80rem] lg:text-base bg-gradient-to-r from-emerald-600 to-emerald-500 rounded-lg max-w-[70%]">
              {{ message.content }}
            </div>
          </section>
        </section>
        <!-- partie pour l'ajout dynamique des questions et suggestions de réponse du bot -->
        <div class="">
          <!-- ***** Message d'ouverture de Léo (Début) **** -->
          <section v-show="beginMsg.length > 0" class="flex flex-col gap-1">
            <!--***** Premier message *****-->
            <section v-if="show1" class="flex flex-col gap-3 p-0">
              <div class="flex items-center gap-6">
                <img :class="{ 'opacity-0': show2 }" class="opacity-1 del animation_chat w-8 h-8 lg:w-10 lg:h-10 m-0"
                  src="../assets/leo.png" alt="mascotteTigre">
                <p
                  class="chat-bubble animation_chat w-[80vw] sm:w-[58vw] md:w-[60vw] xl:w-[51vw] 2xl:[52vw]  p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                  Bonjour, je suis Léo, votre bot Energie.</p>
              </div>
              <Chat_loader v-if="!show2 && !show3 && !showBotAnswer" class="ml-16" />
            </section>
            <!--***** Deuxième message *****-->
            <section v-if="show2" class="flex flex-col gap-3">
              <div class="flex items-center gap-6">
                <img :class="{ 'opacity-0': show3 }" class="opacity-1 animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0"
                  src="../assets/leo.png" alt="mascotteTigre">
                <p
                  class="chat-bubble animation_chat w-[80vw] sm:w-[58vw] md:w-[60vw] xl:w-[51vw] 2xl:[52vw]  p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                  Vous recherchez l’offre énergie qui vous convient ? C’est bien là !!!</p>


              </div>
              <Chat_loader v-if="!show3 && show2 && show1" class="ml-16" />
            </section>
            <!--***** Troisième message *****-->
            <section v-if="show3" class="flex flex-col gap-3">
              <div class="flex items-center gap-6">
                <img :class="{ 'opacity-0': showBotAnswer }"
                  class="opacity-1 animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                  alt="mascotteTigre">
                <p
                  class="chat-bubble animation_chat w-[80vw] sm:w-[58vw] md:w-[60vw] xl:w-[51vw] 2xl:[52vw]  p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                  Faisons connaissance...</p>
              </div>
              <Chat_loader v-if="show3 && show2 && show1 && !showBotAnswer" class="ml-16" />
            </section>
          </section>
          <!-- ***** Message d'ouverture de Léo (Fin) **** -->
          <!-- cette partie affichera les messages du bot -->
          <div class="">
            <div class="">
              <Chat_loader v-if="showAnswerLoader" class="ml-16" />
            </div>
            <!-- ***** Question et suggestion de réponses du bot (Début) **** -->
            <section v-if="showBotAnswer" class="">
              <div>
                <!-- affiche les affirmations du bot -->
                <section v-if="showBotAnswer" v-show="botAnswer.length > 0">
                  <section class="flex flex-col gap-1 mt-[0.25rem] ">
                    <section class="flex flex-col gap-3 ">
                      <div v-if="showAffirmation1" class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showAffirmation2 }" class="del w-8 h-8 lg:w-10 lg:h-10 m-0"
                          src="../assets/leo.png" alt="mascotteTigre">
                        <p
                          class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                          {{ showAffirmation }}</p>
                      </div>
                      <Chat_loader v-if="!showAffirmation2 && showAffirmation1" class="ml-16" />
                    </section>
                    <section class="flex flex-col gap-3 ">
                      <div v-if="showAffirmation2 && botAnswer.length > 1" class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showQuestion }"
                          class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                          alt="mascotteTigre">
                        <p
                          class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                          On continue à faire connaissance...
                        </p>
                      </div>
                      <Chat_loader v-if="showAffirmation1 && showAffirmation2 && !showQuestion" class="ml-16" />
                    </section>
                  </section>
                  <section v-if="showAffirmation3" class="flex flex-col gap-3">
                    <div class="flex items-center gap-6">
                      <img :class="{ 'opacity-0': showQuestion }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0"
                        src="../assets/leo.png" alt="mascotteTigre">
                      <p
                        class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                        {{ showAffirmation }}</p>
                    </div>
                    <Chat_loader v-if="!showQuestion && showAffirmation3" class="ml-16" />
                  </section>
                  <section v-if="showAffirmation4" class="flex flex-col gap-3">
                    <div class="flex items-center gap-6">
                      <img :class="{ 'opacity-0': showQuestion }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0"
                        src="../assets/leo.png" alt="mascotteTigre">
                      <p
                        class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                        {{ showAffirmation }}</p>
                    </div>
                    <Chat_loader v-if="!showQuestion && showAffirmation4" class="ml-16" />
                  </section>
                  <section class="flex flex-col gap-1">
                    <section v-if="showAffirmation5" class="flex flex-col gap-3">
                      <div class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showAffirmation6 }"
                          class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                          alt="mascotteTigre">
                        <p
                          class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                          Merci pour toutes ces informations.</p>
                      </div>
                      <Chat_loader v-if="showAffirmation5 && !showAffirmation6 && !showAffirmation7 && !showQuestion"
                        class="ml-16" />
                    </section>
                    <section v-if="showAffirmation6" class="flex flex-col gap-3">
                      <div class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showAffirmation7 }"
                          class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                          alt="mascotteTigre">
                        <p
                          class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                          Je recherche pour vous l’offre adaptée à vos besoins.
                        </p>
                      </div>
                      <Chat_loader v-if="showAffirmation5 && showAffirmation6 && !showAffirmation7 && !showQuestion"
                        class="ml-16" />
                    </section>
                    <section v-if="showAffirmation7" class="flex flex-col gap-3">
                      <div class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showAffirmation8 }"
                          class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                          alt="mascotteTigre">
                        <p
                          class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base ">
                          Dernier virage !</p>
                      </div>
                      <Chat_loader
                        v-if="showAffirmation5 && showAffirmation6 && showAffirmation7 && !showAffirmation8 && !showQuestion"
                        class="ml-16" />
                    </section>

                    <section v-if="showAffirmation8" class="flex flex-col gap-3">
                      <div class="flex items-center gap-6">
                        <img :class="{ 'opacity-0': showQuestion }"
                          class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png"
                          alt="mascotteTigre">
                      </div>
                      <Chat_loader
                        v-if="showAffirmation5 && showAffirmation6 && showAffirmation7 && showAffirmation8 && !showQuestion"
                        class="ml-16" />
                    </section>

                  </section>
                </section>
                <div class="animation_chat message-left flex flex-col gap-2">
                  <!-- Question avec mascotte -->
                  <div v-if="showQuestion" class="flex items-start gap-6">
                    <img class="del animation_chat w-8 h-8 lg:w-10 lg:h-10 m-0 shrink-0" src="../assets/leo.png"
                      alt="mascotteTigre">
                    <p
                      class="chat_bubble_question w-[80vw] sm:w-[58vw] md:w-[54vw] xl:w-[51vw] p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base">
                      {{ firstQuestion }}
                    </p>
                  </div>
                  <!-- Formulaires alignés avec la bulle (décalage mascotte) -->
                  <div v-if="showQuestion && (isCodePostalForm || isOfferForm || suggested_answers.length > 0)"
                    class="ml-14 lg:ml-16 ">
                    <div class="">
                      <!-- Formulaire Code Postal -->
                      <div v-if="isCodePostalForm">
                        <div class="bg-white rounded-md p-4 mt-3 w-full">
                          <p class="mt-2 pb-2 text-[0.75rem] md:text-[0.80rem] bg-white  lg:text-base">Cela me permet de
                            me concentrer sur les offres disponibles pour vous.</p>
                          <div class="border-2 rounded-lg p-4">
                            <p class="text-[0.75rem] md:text-[0.80rem] lg:text-base">Code Postal <span
                                class="text-gray-400 text-[0.70rem]">(obligatoire)</span></p>
                            <input v-model="codePostal" class="border-2 border-teal-400 w-full mt-2 pl-2 p-1 rounded"
                              placeholder="75001">
                            <div class="mt-2 text-red-500 text-sm" v-if="error">{{ error }}</div>
                          </div>
                          <div class="flex justify-center mt-3">
                            <button @click="getAnswerChosen('SUIVANT')"
                              class="bg-gradient-to-r from-emerald-500 to-emerald-600 text-white p-1 px-4 rounded-md">
                              Suivant
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- Formulaire découverte offre -->
                      <div v-else-if="isOfferForm" class="bg-white p-4 mt-3 w-full">
                        <div>
                          <p>(<span
                              class="text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base font-bold">
                              * </span>)
                            Champs
                            obligatoires</p>
                        </div>
                        <div class="flex flex-col mt-3 w-full ">
                          <!-- Form1 -->
                          <div class="border-2 rounded-lg p-3">
                            <div class="flex flex-wrap gap-2 ">

                              <div class="mb-4 w-full mx-2">
                                <label for="telephone"
                                  class="block text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base font-medium text-gray-600"><span
                                    class="text-black text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base font-bold">*</span>
                                  Téléphone
                                  :</label>
                                <input id="telephone"
                                  class="mt-1 p-1 border-2 border-solid rounded-md  w-full text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base"
                                  placeholder="veuillez entrer votre numéro" type="tel" v-model="numero_client">
                                <p v-if="numeroError"
                                  class="text-red-500 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                                  {{ numeroError
                                  }}</p>
                              </div>
                            </div>
                            <div class="flex justify-center">
                              <button v-if="showSuivantButton" @click="nextStep()"
                                class="bg-gradient-to-r from-emerald-500 to-emerald-600 text-white m-1 mb-1 p-1 px-2 rounded-md">Suivant</button>
                            </div>
                          </div>
                          <!-- Form2 -->
                          <div v-if="currentStep" class="mt-[1.5rem] text-justify flex flex-col mb-1">
                            <div class="mb-[0.75rem]">
                              <input id="firstAgreement" type="checkbox" class="mr-2" v-model="firstAgreement">
                              <label for="firstAgreement"
                                class="text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                                J’accepte que l’un des
                                <span class="relative inline-block">
                                  <span class="text-purple-500 cursor-pointer"
                                    @mouseenter="activePartenairesTooltip = 'firstAgreement'"
                                    @mouseleave="activePartenairesTooltip = null">partenaires</span>
                                  <div v-if="activePartenairesTooltip === 'firstAgreement'"
                                    class="absolute bottom-full left-0 p-2 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 w-[220px] text-sm text-gray-800">
                                    <p v-for="partnerName in partenairesList" :key="`first-${partnerName}`"
                                      class="font-semibold">
                                      {{ partnerName }}
                                    </p>
                                  </div>
                                </span>
                                de <span>meilleuresoffresenergies.fr</span> me contacte par téléphone en vue de me
                                proposer une offre d’énergie, conformément à nos <a target="_blank" href="/conditionsgenerales"
                                  class="underline">CGU</a> <span class="font-semibold">(obligatoire)</span>
                              </label>
                            </div>
                            <div class="mb-[0.75rem]">
                              <input id="secondAgreement" type="checkbox" class="mr-2" v-model="secondAgreement">
                              <label for="secondAgreement"
                                class="text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                                J’accepte que
                                <span>meilleuresoffresenergies.fr</span> me contacte par SMS, RCS ou Whatsapp
                                à des fins de prospection commerciales électronique pour recevoir d’autres offres
                                promotionnelles, conformément à nos <a target="_blank" href="/conditionsgenerales"
                                  class="underline">CGU</a> <span class="font-semibold">(optionnel)</span>
                              </label>
                            </div>
                            <div
                              class="text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base mb-[0.75rem]">
                              <span>meilleuresoffresenergies.fr</span> et ses
                              <span class="relative inline-block">
                                <span class="text-purple-500 cursor-pointer"
                                  @mouseenter="activePartenairesTooltip = 'consentement'"
                                  @mouseleave="activePartenairesTooltip = null">partenaires</span>
                                <div v-if="activePartenairesTooltip === 'consentement'"
                                  class="absolute bottom-full left-0 p-2 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 w-[220px] text-sm text-gray-800">
                                  <p v-for="partnerName in partenairesList" :key="`consent-${partnerName}`"
                                    class="font-semibold">
                                    {{ partnerName }}
                                  </p>
                                </div>
                              </span>
                              traitent les données recueillies afin de vous recontacter en vue de vous proposer une
                              offre d’énergie même dans l’éventualité où vous étiez inscrit sur la liste Bloctel. Ce
                              consentement prévaut sur la loi visant à encadrer le démarchage téléphonique et à lutter
                              contre les appels frauduleux. Pour en savoir plus sur la gestion de vos données
                              personnelles et pour exercer vos droits, veuillez consulter notre <a
                                class="underline break-words" target="_blank"
                                href="https://meilleuresoffresenergies.fr/politiqueConfidentialite">politique de
                                confidentialité</a>.
                            </div>
                            <div
                              class="text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base font-bold text-center">
                              Ce contact est entièrement gratuit et sans aucun engagement de votre part.
                            </div>
                            <!-- Bouton Je découvre mon offre -->
                            <div class="flex justify-center mt-4">
                              <button @click="getAnswerChosen('Je découvre mon offre')" :disabled="isDisabled"
                                :class="isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-emerald-600 hover:bg-emerald-700'"
                                class="transition-all duration-500 ease-out font-semibold text-white p-2 px-6 rounded-md text-[0.75rem] lg:text-[0.85rem]">
                                Je découvre mon offre
                              </button>
                            </div>
                          </div>
                          <p v-if="showCGUmsg"
                            class="text-red-600 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                            Merci de prendre
                            connaissance de nos
                            <span class="underline">CGU</span> avant d'accéder à votre offre.
                          </p>
                        </div>
                      </div>
                      <!-- Affiche les réponses basiques -->
                      <!-- <section class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mt-4"> -->
                      <section class="flex flex-wrap justify-center items-center  gap-6 lg:gap-10 mt-4">
                        <div class="flex flex-col justify-center md:items-center cursor-pointer"
                          :disabled="chooseAnswer" v-for="(value, index) in suggested_answers" :key="index"
                          @click="showAnswerButton && value.answer !== 'Je découvre mon offre' ? getAnswerChosen(value.answer) : null">
                          <img v-if="value.answerImg != null" class="mx-auto object-cover w-[60px] h-[60px]"
                            :src="value.answerImg" alt="mascotteTigre">

                          <button v-if="showAnswerButton && value.answer === 'Je découvre mon offre' && !currentStep"
                            @click.stop="getAnswerChosen(value.answer)" :disabled="isDisabled"
                            :class="isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-emerald-600 hover:bg-emerald-700'"
                            class="transition-all duration-500 ease-out font-semibold text-white p-2 w-[120px] md:w-[130px] lg:w-[200px] rounded-md text-[0.70rem] lg:text-[0.80rem]">
                            Je découvre mon offre
                          </button>


                          <button v-if="showAnswerButton && value.answer !== 'Je découvre mon offre'"
                            @click.stop="getAnswerChosen(value.answer)"
                            class="bg-emerald-600  transition-all duration-500 ease-out font-semibold text-white p-1 w-[100px] md:w-[100px] lg:w-[170px] rounded-md text-[0.70rem] lg:text-[0.80rem]">
                            {{ value.answer }}
                          </button>

                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- ***** Question et suggestion de réponses du bot (Fin) **** -->
          </div>
        </div>
        <div class="flex flex-col gap-1 mt-[0.25rem]">
          <section class="flex flex-col gap-3" v-if="messageOffer1">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': offerEnie }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0"
                src="../assets/leo.png" alt="mascotteTigre">
              <p
                class="chat_bubble_question animation_chat w-[80vw] sm:w-[58vw] md:w-[54vw]  p-2 text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                Patience... votre offre apparaît d'ici quelques
                secondes...</p>
            </div>
            <Chat_loader v-if="currentMessage === 1" class="ml-16" />
          </section>

          <section class="flex flex-col gap-3" v-if="offerEnie">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer2 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <div
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  <p>L'offre qui semble correspondre à votre recherche est chez :</p>
                  <div
                    class="mx-auto mt-[1rem] flex max-w-[240px] flex-col items-center justify-center gap-3 rounded-x p-4 text-center">
                    <img class="w-[88px] h-[88px]" src="../assets/plenitude.png" alt="mascotteTigre">
                    <p class="font-semibold text-[#128c7e]">L'énergie est notre avenir, économisons-la !</p>
                  </div>
                </div>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 2 || currentMessage === 3" class="ml-16 " />
          </section>

          <section class="flex flex-col gap-3" v-if="messageOffer3">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer4 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Je transmets vos réponses à notre conseiller, Il vous appelle d’ici quelques minutes…
                </p>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 4" class="ml-16 " />
          </section>
          <section class="flex flex-col gap-3" v-if="messageOffer4">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer5 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Surtout restez près de votre téléphone 📞
                </p>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 5" class="ml-16 " />
          </section>
          <section class="flex flex-col gap-3" v-if="messageOffer5">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer6 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Merci de vous connecter à l’espace client de votre fournisseur actuel ou d’avoir une facture à portée
                  de main : notre conseiller sera plus précis dans sa proposition.
                </p>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 6" class="ml-16 " />
          </section>
          <section class="flex flex-col gap-3" v-if="messageOffer6">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer7 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Et quant à moi, je vous souhaite une excellente journée et, bien sûr une nouvelle expérience Energie !
                  😉
                </p>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 7" class="ml-16 " />
          </section>
          <section class="flex flex-col gap-3" v-if="messageOffer7">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer8 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Soyez prêt(e) à décrocher pour profiter de votre offre au plus vite.
                </p>
              </div>
            </div>
            <Chat_loader v-if="currentMessage === 8" class="ml-16 " />
          </section>

          <!-- Partie affichant 'Offre non éligible' -->
          <section class="flex flex-col gap-3" v-if="nonEligible">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': nonEligible1 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] font-semibold text-red-600 sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Désolé, nous n’avons actuellement pas d’offre disponible dans votre commune.
                </p>
              </div>
            </div>
            <Chat_loader class="ml-16 " v-if="currentEniMessage" />
          </section>
          <section class="flex flex-col gap-3" v-if="nonEligible1">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': nonEligible2 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <p
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  Nous vous remercions de votre visite sur notre site ! Restez à l'affût, nos offres évoluent
                  constamment. Revenez nous voir pour ne rien manquer !
                </p>
              </div>
            </div>
            <Chat_loader class="ml-16 " v-if="currentEniMessage1" />
          </section>
          <section class="flex flex-col gap-3" v-if="nonEligible2">
            <div class="flex items-center gap-6">
              <img :class="{ 'opacity-0': messageOffer8 }" class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0 "
                src="../assets/leo.png" alt="mascotteTigre">
              <div class="">
                <div
                  class="chat_bubble_question animation_chat p-2 w-[80vw] sm:w-[58vw] md:w-[54vw]  xl:w-[51vw] 2xl:[52vw] text-[0.75rem] md:text-[0.80rem] lg:text-base xl:text-base 2xl:text-base">
                  <p>Vous pouvez encore économiser sur votre forfait internet. Souhaitez-vous profitez de nos offres ?
                  </p>
                  <p class="text-center p-1 mt-3"><a href="https://meilleursforfaitsinternet.fr/" target="_blank"
                      class="bg-[#128c7e] rounded-lg p-1 px-2 text-white"> OUI </a></p>
                </div>
              </div>
            </div>
            <Chat_loader class="ml-16 " v-if="currentEniMessage2" />
          </section>

          <section class="flex items-center gap-6" v-if="messageOffer8">
            <img class="animation_chat del w-8 h-8 lg:w-10 lg:h-10 m-0" src="../assets/leo.png" alt="mascotteTigre" />
            <chatbotPartage />
          </section>
        </div>
      </div>
    </div>
    <!-- Modal de relance de l'utilisateur -->
    <relanceModal v-if="openRelanceModal" @close="closeRelanceModal()" :relance1="relance1" :relance2="relance2"
      :relance3="relance3" />
    <!-- Modal d'au revoir -->
    <GoodByeModal @close="closeGoodByeModal()" v-if="openGoodByeModal" />
    <!-- Modal de consentement aux cookies -->
    <cookiesModal class="cookiesAnimation" @close="closeCookiesModal()" v-if="openCookiesModal" />
    <!-- Modal aucune offre (PLENITUDE) -->
    <AucuneOffreModal v-if="showAucuneOffreModal" @retry="retryConversation" />
    <img @click="showCookiesModal()" v-if="!openCookiesModal && showIconCookies"
      class="fixed bottom-[6%] lg:bottom-[8%] sm:bottom-[8%] md:bottom-[16%] w-10 md:w-12  lg:w-18 h-10 md:h-12  lg:h-18 left-0 -[10%]"
      src="../assets/tigre_cookies.png" alt="tigre_cookies">
  </main>
  <!-- le pied de page de l'interface de conversation -->
  <chatFooter />
  <!-- Loader au chargement de la page -->
  <Initial_loader v-if="showInitialLoader" class="loaderStyle" />
</template>

<script setup>

/***
 * Importations des ressources nécessaires
 */
import { onMounted, ref, watch } from 'vue';
import config from "@/main.js";
import axios from 'axios';
// Importation du loader à afficher au chargement de la page
import Initial_loader from '@/components/First_loader.vue'
// Importation du loader à afficher lorsqu'un message est en cours de chargement
import Chat_loader from '@/components/chat_loader.vue'
import chatbotPartage from '@/components/chatbot/chatbotPartage.vue';

import chatHeader from '@/components/chatbot/chatbotHeader.vue';
import chatFooter from '@/components/chatbot/chatbotFooter.vue';
import relanceModal from '@/components/chatbot/RelanceModal.vue';
import cookiesModal from '@/components/chatbot/CookiesModal.vue';
import GoodByeModal from '@/components/chatbot/GoodByeModal.vue';
import AucuneOffreModal from '@/components/chatbot/AucuneOffreModal.vue';


/********************  Modal de relance *********************/


/***
 * Déclaration des variables
 */
const relance1 = ref(false)
const relance2 = ref(false)
const relance3 = ref(false)
const openRelanceModal = ref(false)
const showIconCookies = ref(false)
let clearInactivity = ref(null)
let isDisabled = ref(true)


//données pour les formulaires
// const emailError = ref('');
const numeroError = ref('');
const showError = ref('');
//const email_client = ref(null)
const numero_client = ref(null)
const firstAgreement = ref(false)
const fournisseur_elec = ref(null)
const fournisseur_gaz = ref(null)
const motivation = ref(null)
// const secondAgreement = ref(null)
const codePostal = ref(null)



// Fermer  le modal de relance
const closeRelanceModal = () => {
  openRelanceModal.value = false
}

const openCookiesModal = ref(false);
setTimeout(() => {
  openCookiesModal.value = true
}, 10000);

/***
 * Méthodes
 */

// L'ensemble des fonctions suivantes sont pour gérer l'interaction des utilisateurs sur le bouton je découvre mon offre
watch(firstAgreement, (newVal) => {
  if (newVal) {
    isDisabled.value = false;
  } else {
    isDisabled.value = true;
  }
});

///------fin------///

// Affiche le modal des cookies
const showCookiesModal = () => {
  openCookiesModal.value = true
  showIconCookies.value = false
}
// Fermer le modal des cookies
const closeCookiesModal = () => {
  openCookiesModal.value = false
  showIconCookies.value = true
}

const openGoodByeModal = ref(false);

const closeGoodByeModal = () => {
  openGoodByeModal.value = false
  clearTimeout(clearInactivity.value)
  clearTimeout(setIntervalDelete.value);

}

const offerEnie = ref(false)
const messageOffer1 = ref(false)
const messageOffer2 = ref(false)
const messageOffer3 = ref(false)
const messageOffer4 = ref(false)
const messageOffer5 = ref(false)
const messageOffer6 = ref(false)
const messageOffer7 = ref(false)
const messageOffer8 = ref(false)
const nonEligible = ref(false)
const nonEligible1 = ref(false)
const nonEligible2 = ref(false)

const show1 = ref(true)
const show2 = ref(false)
const show3 = ref(false)
const showAnswerButton = ref(true)
const showQuestion = ref(false)
const messageFinal = ref(false)


setTimeout(() => {
  show2.value = true;
}, 4000);
setTimeout(() => {
  show3.value = true;
}, 6000);


const currentStep = ref(false);
const nextStep = () => {
  // Validation logic
  // if (!email_client.value) {
  //   emailError.value = 'Veuillez entrer un mail.';
  // } else if (!isEmailValid(email_client.value)) {
  //   emailError.value = 'Veuillez saisir une adresse e-mail valide.';
  // } else {
  //   emailError.value = ''
  // }

  if (!numero_client.value) {
    numeroError.value = 'Veuillez entrer un numéro à 10 chiffres.';
  } else if (!isValidPhoneNumber(numero_client.value)) {
    numeroError.value = 'Veuillez saisir un numéro de téléphone valide à 10 chiffres .';
  } else {
    numeroError.value = '';
  }



  // Check if all fields are valid
  if (isValidPhoneNumber(numero_client.value)) {
    currentStep.value++;
    showAnswerButton.value = true
    showSuivantButton.value = false
    return true
  } else {
    currentStep.value = false;
    showAnswerButton.value = false
    return false
  }
}

const setIntervalDelete = ref(null)
const showSuivantButton = ref(true)

// variable de controle du scrool
const pageContainer = ref(null);

// Variable affichant ou non le loader initial
const showInitialLoader = ref(true)
// Variable affichant ou non les message du bot
const showBotAnswer = ref(false)
// Variable affichant ou non le loader lors du chargement d'un message
const beginMsg = ref(['  Bonjour, je suis Léo, votre bot Energie.', "Vous recherchez l’offre énergie qui vous convient ? C’est bien là !!!", "Faisons connaissance..."])
const endMsg = ref(null)
const firstQuestion = ref(' En plus de sécuriser votre budget, pourquoi changer de fournisseur ?')

const suggested_answers = ref([
  { answer: 'Une énergie verte', answerImg: require('@/assets/energie_verte.png') },
  { answer: 'Un service client disponible', answerImg: require('@/assets/conseiller.png') },
  { answer: 'J\'emménage', answerImg: require('@/assets/emmenagement.png') },
  { answer: 'Autre', answerImg: require('@/assets/logo_autre.png') },
])
const error = ref('')

const answerChosen = ref(null)
const conversation_id = ref(null)
const visitor_id = ref(null)
const botAnswer = ref([])

const isCodePostalForm = ref(false)
const isOfferForm = ref(false)
const showCGUmsg = ref(false)

const historyMessage = ref({})
const chatHistory = ref([])
const count = ref(0)

// const modalAdsl = ref(false)
// const modalOui = ref(false)

const offer = ref(null)
// const conversation_modele = ref(null)
const weight = ref(0)
const goNext = ref(false)

const checkInactivity = () => {
  // Vérifier si le compteur d'inactivité a atteint la limite
  if (count.value >= 300) {  // 300 secondes (5 minutes) d'inactivité, ajustez selon vos besoins
    openRelanceModal.value = true;
  }
};

// Utiliser setTimeout pour vérifier l'inactivité après un certain temps
const startInactivityCheck = () => {
  clearInactivity.value = setTimeout(checkInactivity, 300000);
};

const beginDiscussion = (question, answer) => {
  axios.post(`${config.BACK_URL}/init_discussion.php`, {
    question: question,
    answer: answer
  }).then((response) => {
    conversation_id.value = response.data.conversation_id
    visitor_id.value = response.data.visitor_id
  })

}

const energieElectricite = ref(false)
const energieGaz = ref(false)
const electricityGaz = ref(false)

onMounted(() => {
  startInactivityCheck();
  resetActivityTimeout();

  setTimeout(() => {
    showInitialLoader.value = false
  }, 2000);
  setTimeout(() => {

    setTimeout(() => {
      showQuestion.value = true
      showBotAnswer.value = true
    }, 6000);


    endMsg.value = '';
    historyMessage.value = { role: "bot", welcomeMsg: beginMsg.value, question: firstQuestion.value, suggested_answers: suggested_answers.value, affirmation: [] }


    return historyMessage
  }, 2000)


})

// fonction qui gère le scroll automatique du chatbot
const scrollToBottom = () => {
  if (pageContainer.value) {
    pageContainer.value.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }
};

// fonction utilisée en local
//  const verifierCodePostal = async () => {
//    if (/^\d{5}$/.test(codePostal.value)) {
//      error.value = '';
//    } else {
//      error.value = 'Saisissez un code postal à 5 chiffres (exemple: 75001).';
//    }
//  };


/**
 * fonction utilisée pour la vérification du code postal
 */
//const verifierCodePostal = async () => {
// if (/^\d{5}$/.test(codePostal.value)) {
//   try {
//     await axios.post(`${config.BACK_URL}/check_code_postal.php`, { codePostal: codePostal.value,  energie: energietype.value})
//       .then((response) => {
//         if (response.data.statut == 200) {
//           error.value = '';
//         } else {
//           error.value = 'Le code postal saisi n\'existe pas. Veuillez saisir un code existant.';
//         }
//       });
//
//   } catch (err) {
//     error.value = 'Une erreur s\'est produite lors de la vérification du code postal.';
//   }
// } else {
//   error.value = 'Saisissez un code postal à 5 chiffres (exemple: 75001).';
// }
//};

const submitForm = () => {

  if (!firstAgreement.value) {
    showError.value = true;
    return false
  } else {
    showError.value = '';
    return true
  }

};

const getMarketingParams = () => {
  try {
    return JSON.parse(localStorage.getItem('marketingParams') || '{}');
  } catch (error) {
    return {};
  }
};

// const isEmailValid = (email) => {
//   // Utiliser une expression régulière pour vérifier si c'est un email valide
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return emailRegex.test(email);
// };

const isValidPhoneNumber = (phoneNumber) => {
  // const phoneRegex = /^(01|02|03|04|05|06|07|08|09)\d{8}$/
  const phoneRegex = /^(01|02|03|04|05|06|07|08|09)(?!.*00000)\d{8}$/
  return phoneRegex.test(phoneNumber);
};

// let stopExecution = ref(false);

let currentMessage = ref(null)
let currentEniMessage = ref(false)
let currentEniMessage1 = ref(false)
let currentEniMessage2 = ref(false)
// const affirmation = ref("")
const showAffirmation = ref("")
const showAffirmation1 = ref(false)
const showAffirmation2 = ref(false)
const showAffirmation3 = ref(false)
const showAffirmation4 = ref(false)
const showAffirmation5 = ref(false)
const showAffirmation6 = ref(false)
const showAffirmation7 = ref(false)
const showAffirmation8 = ref(false)

const resetAffirmations = () => {
  showAffirmation1.value = false
  showAffirmation2.value = false
  showAffirmation3.value = false
  showAffirmation4.value = false
  showAffirmation5.value = false
  showAffirmation6.value = false
  showAffirmation7.value = false
  showAffirmation8.value = false
  showAffirmation.value = ''
}
const showAnswerLoader = ref(false)
// const disabledButtons = ref({})
let currentEnergySelection = ref(0)
const isMoving = ref(false)
const les_deux = ref(false)
let isElectricitySelected = ref(false);
let isGazSelected = ref(false);
let VariableEni = ref(false);
let energietype = ref(null);
let price = ref(null);
let demenagement = ref(null);

/**
 * Fonction utilisée pour envoyer les informations collectées durant la conversation
 */
const sendLead = async () => {
  const marketingParams = getMarketingParams()

  axios.post(`${config.BACK_URL}/index.php`, {
    fournisseur_gaz: fournisseur_gaz.value,
    fournisseur_elec: fournisseur_elec.value,
    cout_facture: price.value,
    motivation: motivation.value,
    codePostal: codePostal.value,
    energie_type: energietype.value,
    // email: email_client.value,
    telephone: numero_client.value,
    consentement: firstAgreement.value,
    demenagement: demenagement.value != null ? 'Oui' : 'Non',
    lead_id: conversation_id.value,
    provenance: localStorage.getItem('IPSMS'),
    utm_source: marketingParams.utm_source ?? null,
    utm_medium: marketingParams.utm_medium ?? null,
    utm_campaign: marketingParams.utm_campaign ?? null,
    utm_content: marketingParams.utm_content ?? null,
    utm_term: marketingParams.utm_term ?? null,
    ad_id: marketingParams.ad_id ?? null,
    camp_id: marketingParams.camp_id ?? null,
    adset_id: marketingParams.adset_id ?? null
  }).then(() => {

  })
}

//fonction pour enregistrer les actions de l'utilisateur

const tracking_action = (conversation_id, visitor_id, question, answer) => {
  axios.post(`${config.BACK_URL}/tracking_action.php`, {
    conversation_id: conversation_id,
    visitor_id: visitor_id,
    question: question,
    answer: answer,
  })
}

//Cette fonction permet de renvoyer la question suivante et d'assurer le maintien du fil de la discussion
const getAnswerChosen = async (answer) => {
  clearInterval(setIntervalDelete.value)

  if (answer === 'Electricité') {
    isElectricitySelected.value = true;
  } else if (answer === 'Gaz') {
    isGazSelected.value = true
  }

  if (answer === 'ENI') {
    VariableEni.value = true
  }

  if (answer == 'SUIVANT') {
    const normalizedCodePostal = codePostal.value?.trim() || ''

    if (!normalizedCodePostal) {
      error.value = 'Veuillez renseigner votre code postal.';
    } else if (!/^\d{5}$/.test(normalizedCodePostal)) {
      error.value = 'Saisissez un code postal à 5 chiffres (exemple: 75001).';
    } else {
      error.value = '';
      codePostal.value = normalizedCodePostal
    }

    if (error.value == '') {

      answerChosen.value = normalizedCodePostal
      tracking_action(conversation_id.value, visitor_id.value, firstQuestion.value, normalizedCodePostal)
      chatHistory.value.push(historyMessage.value)
      chatHistory.value.push({ role: "user", content: normalizedCodePostal })
      resetAffirmations()
      localStorage.setItem('chatHistory', chatHistory)
      beginMsg.value = []
      showAnswerLoader.value = true
      showQuestion.value = false
      isCodePostalForm.value = false
      showAffirmation4.value = false
      weight.value++
      botAnswer.value = []

      setTimeout(() => {
        showAnswerLoader.value = false
        showBotAnswer.value = true

        window.removeEventListener('mousemove', resetActivityTimeout);
        window.removeEventListener('keydown', resetActivityTimeout);
        botAnswer.value = ['Merci pour toutes ces informations. ', "Je recherche pour vous l’offre adaptée à vos besoins", "Dernier virage !", "Bonne nouvelle ! Nous avons trouvé l'offre qui répond à vos attentes."]
        showAnswerButton.value = false;
        firstQuestion.value = 'Renseignez vos coordonnées et découvrez votre offre !';
        suggested_answers.value = [{ answer: 'Je découvre mon offre', answerImg: null }];
        isOfferForm.value = true
        isCodePostalForm.value = false
        showSuivantButton.value = true
        currentStep.value = false
        showAffirmation5.value = true
        setTimeout(() => { showAffirmation6.value = true }, 1500);
        setTimeout(() => { showAffirmation7.value = true }, 3000);
        setTimeout(() => { showAffirmation8.value = true }, 4500);
        setTimeout(() => { showQuestion.value = true }, botAnswer.value.length * 1500)

        answerChosen.value = null
        historyMessage.value = { role: "bot", welcomeMsg: [], question: firstQuestion.value, suggested_answers: suggested_answers.value, affirmation: botAnswer.value }
        scrollToBottom();
      }, 1500);
    } else {
      isCodePostalForm.value = true
    }

  } else if (answer == 'Je découvre mon offre') {

    if (!numero_client.value) {
      numeroError.value = 'Veuillez entrer un numéro à 10 chiffres.';
      return;
    } else if (!isValidPhoneNumber(numero_client.value)) {
      numeroError.value = 'Le format du numéro de téléphone est invalide.';
      return;
    } else {
      numeroError.value = '';
    }

    if (submitForm()) {
      // Si le fournisseur est PLENITUDE → aucune offre disponible
      if (fournisseur_elec.value === 'PLENITUDE' || fournisseur_gaz.value === 'PLENITUDE') {
        showAucuneOffreModal.value = true
        return
      }

      showQuestion.value = false
      isOfferForm.value = false
      showCGUmsg.value = false

      await sendLead()

      chatHistory.value.push(historyMessage.value)
      chatHistory.value.push({ role: "user", content: answer })
      resetAffirmations()
      tracking_action(conversation_id.value, visitor_id.value, firstQuestion.value, answer)
      localStorage.setItem('chatHistory', chatHistory)
      beginMsg.value = []
      showAnswerLoader.value = true
      showBotAnswer.value = false
      setTimeout(() => {
        showAnswerLoader.value = false
        showBotAnswer.value = true
        showQuestion.value = false
        messageFinal.value = true
        weight.value++
        botAnswer.value = []
        if (weight.value) {
          messageOffer1.value = true;
          currentMessage.value = 1;

          setTimeout(() => {
            offerEnie.value = true;
            currentMessage.value = 2;
          }, 6000);

          setTimeout(() => {
            if (isElectricitySelected.value) {
              energieElectricite.value = true;
            } else if (isGazSelected.value) {
              energieGaz.value = true;
            } else {
              if (les_deux.value == true && fournisseur_elec.value == 'ENI' && fournisseur_gaz.value != 'ENI') {
                energieGaz.value = true;
              } else if (les_deux.value == true && fournisseur_elec.value != 'ENI' && fournisseur_gaz.value == 'ENI') {
                energieElectricite.value = true;
              } else if (les_deux.value == true && fournisseur_elec.value != 'ENI' && fournisseur_gaz.value != 'ENI') {
                electricityGaz.value = true
              }
            }
            messageOffer2.value = true;
            currentMessage.value = 3;
          }, 8000);

          setTimeout(() => { messageOffer3.value = true; currentMessage.value = 4; }, 10000);
          setTimeout(() => { messageOffer4.value = true; currentMessage.value = 5; }, 12000);
          setTimeout(() => { messageOffer5.value = true; currentMessage.value = 6; }, 14000);
          setTimeout(() => { messageOffer6.value = true; currentMessage.value = 7; }, 16000);
          setTimeout(() => { messageOffer7.value = true; currentMessage.value = 8; }, 18000);
          setTimeout(() => { messageOffer8.value = true; currentMessage.value = 9; }, 19000);
        }

        answerChosen.value = null
        historyMessage.value = { role: "bot", welcomeMsg: [], question: firstQuestion.value, suggested_answers: suggested_answers.value, affirmation: botAnswer.value }
        return historyMessage, isCodePostalForm, isOfferForm, offer
      }, 1500);

      scrollToBottom();
    } else {
      isOfferForm.value = true
      showCGUmsg.value = true
    }

    window.removeEventListener('mousemove', resetActivityTimeout);
    window.removeEventListener('keydown', resetActivityTimeout);

  } else {

    showQuestion.value = false

    if (firstQuestion.value == ' En plus de sécuriser votre budget, pourquoi changer de fournisseur ?') {
      motivation.value = answer
      beginDiscussion(firstQuestion.value, answer)
    } else {
      tracking_action(conversation_id.value, visitor_id.value, firstQuestion.value, answer)
    }

    answerChosen.value = answer
    chatHistory.value.push(historyMessage.value)
    chatHistory.value.push({ role: "user", content: answer })
    resetAffirmations()
    localStorage.setItem('chatHistory', chatHistory)
    beginMsg.value = []
    showAnswerLoader.value = true
    showBotAnswer.value = false
    setTimeout(() => {
      showAnswerLoader.value = false
      showBotAnswer.value = true

      if (goNext.value == true) {
        if (firstQuestion.value == 'Renseignez vos coordonnées et découvrez votre offre !') {
          weight.value++
        } else {
          weight.value = 5
        }
      } else {
        weight.value++
      }

      switch (answerChosen.value) {
        case 'Electricité':
        case 'Gaz':
          energietype.value = answerChosen.value;
          if (isMoving.value) {
            botAnswer.value = []
            weight.value = 4;
          } else {
            botAnswer.value = ['Encore quelques questions pour finaliser notre recherche…'];
          }
          break;
        case 'Les deux':
          energietype.value = answerChosen.value;
          if (isMoving.value) {
            botAnswer.value = []
            weight.value = 4;
          } else {
            botAnswer.value = ['Encore quelques questions pour finaliser notre recherche…'];
            les_deux.value = true
          }
          break;

        case 'Une énergie verte':
          botAnswer.value = ['C\'est noté, trouvons ensemble l\'offre qui va vous permettre de bénéficier d\'une énergie verte...']
          break
        case 'Un service client disponible':
          botAnswer.value = ['C\'est noté, trouvons ensemble l\'offre qui va vous permettre de bénéficier d\'un service client disponible...']
          break
        case 'J\'emménage':
          demenagement.value = answerChosen.value
          botAnswer.value = ['C\'est noté, trouvons ensemble l\'offre qui va vous permettre de vous installer en toute tranquilité...']
          isMoving.value = true;
          break
        case 'Autre':
          botAnswer.value = ['C\'est noté, allons plus loin pour mieux comprendre vos besoins...']
          break

        case 'Moins de 100 €':
        case 'Entre 100 et 150 €':
        case 'Entre 150 et 200 €':
        case 'Je ne sais pas':
          price.value = answerChosen.value
          break

        case 'AUTRE':
        case 'ENGIE':
        case 'TOTAL ENERGIES':
        case 'ENI':
        case 'EDF':
        case 'SOWEE':
        case 'PLENITUDE':
          botAnswer.value = []
          if (answer === 'ENI') VariableEni.value = true
          if (energietype.value == 'Gaz') {
            fournisseur_gaz.value = answerChosen.value
          } else if (energietype.value == 'Electricité') {
            fournisseur_elec.value = answerChosen.value
          } else if (energietype.value == 'Les deux' && firstQuestion.value == 'Et vous êtes chez qui pour le gaz ?') {
            fournisseur_gaz.value = answerChosen.value
          } else if (energietype.value == 'Les deux' && firstQuestion.value == 'Et vous êtes chez qui pour l\u2019électricité ?') {
            fournisseur_elec.value = answerChosen.value
          }
          break
      }

      switch (weight.value) {
        case 1:
          firstQuestion.value = 'Et sur quelle énergie souhaitez-vous que l\'on regarde ?';
          suggested_answers.value = [
            { answer: 'Electricité', answerImg: require('@/assets/electricity.png') },
            { answer: 'Gaz', answerImg: require('@/assets/gaz.png') },
            { answer: 'Les deux', answerImg: require('@/assets/les_deux.png') },
          ];
          break;

        case 2:
          if (les_deux.value) {
            lesDeux()
          } else {
            firstQuestion.value = 'Et vous êtes chez qui actuellement ?';
            suggested_answers.value = [
              { answer: 'ENGIE', answerImg: require('@/assets/logo_engie.png') },
              { answer: 'TOTAL ENERGIES', answerImg: require('@/assets/logo_total.png') },
              { answer: 'PLENITUDE', answerImg: require('@/assets/plenitude.png') },
              { answer: 'EDF', answerImg: require('@/assets/logo_edf.png') },
              { answer: 'SOWEE', answerImg: require('@/assets/logo_sowee.png') },
              { answer: 'AUTRE', answerImg: require('@/assets/logo_autre.png') },
            ];
          }
          break;

        case 3:
          firstQuestion.value = 'Actuellement, à combien s\'élève vos factures mensuelles ?  🙂'
          suggested_answers.value = [
            { answer: 'Moins de 100 €', answerImg: null },
            { answer: 'Entre 100 et 150 €', answerImg: null },
            { answer: 'Entre 150 et 200 €', answerImg: null },
            { answer: 'Je ne sais pas', answerImg: null },
          ]
          break

        case 4:
          firstQuestion.value = 'Parfait ! pouvez-vous m\'indiquer le code postal de votre commune, s\'il vous plaît ?'
          suggested_answers.value = []
          isCodePostalForm.value = true
          break

        case 5:
          window.removeEventListener('mousemove', resetActivityTimeout);
          window.removeEventListener('keydown', resetActivityTimeout);
          botAnswer.value = ['Merci pour toutes ces informations. ', "Je recherche pour vous l’offre adaptée à vos besoins.", "Dernier virage !", "Bonne nouvelle ! Nous avons trouvé l'offre qui répond à vos attentes."]
          showAnswerButton.value = false;
          firstQuestion.value = 'Renseignez vos coordonnées et découvrez votre offre !';
          suggested_answers.value = [{ answer: 'Je découvre mon offre', answerImg: null }];
          isCodePostalForm.value = false
          break;
      }

      if (botAnswer.value.length > 0) {
        if (
          botAnswer.value[0] == 'C\'est noté, trouvons ensemble l\'offre qui va vous permettre de bénéficier d\'une énergie verte...' ||
          botAnswer.value[0] == 'C\'est noté, trouvons ensemble l\'offre qui va vous permettre de bénéficier d\'un service client disponible...' ||
          botAnswer.value[0] == 'C\'est noté, trouvons ensemble l\'offre qui va vous permettre de vous installer en toute tranquilité...' ||
          botAnswer.value[0] == 'C\'est noté, allons plus loin pour mieux comprendre vos besoins...'
        ) {
          showAffirmation.value = botAnswer.value[0]
          showAffirmation1.value = false
          showAffirmation2.value = false
          showAffirmation3.value = true
          showAffirmation4.value = false
          showAffirmation5.value = false
          showAffirmation6.value = false
          showAffirmation7.value = false
          showAffirmation8.value = false
        }
        if (botAnswer.value[0] == 'Encore quelques questions pour finaliser notre recherche…') {
          showAffirmation.value = botAnswer.value[0]
          showAffirmation1.value = false
          showAffirmation2.value = false
          showAffirmation3.value = true
          showAffirmation4.value = false
          showAffirmation5.value = false
          showAffirmation6.value = false
          showAffirmation7.value = false
          showAffirmation8.value = false
        }
        if (botAnswer.value[0] == 'Merci pour toutes ces informations. ') {
          showAffirmation1.value = false
          showAffirmation2.value = false
          showAffirmation3.value = false
          showAffirmation4.value = false
          showAffirmation5.value = true
          setTimeout(() => { showAffirmation6.value = true }, 1500);
          setTimeout(() => { showAffirmation7.value = true }, 3000);
          setTimeout(() => { showAffirmation8.value = true }, 4500);
        }
      }

      setTimeout(() => {
        showQuestion.value = true
      }, botAnswer.value.length * 1500)

      if (firstQuestion.value.indexOf('code postal') !== -1) {
        isCodePostalForm.value = true
      }
      if (firstQuestion.value.indexOf('découvrez votre offre') !== -1) {
        isOfferForm.value = true
      }

      answerChosen.value = null
      historyMessage.value = { role: "bot", welcomeMsg: [], question: firstQuestion.value, suggested_answers: suggested_answers.value, affirmation: botAnswer.value }
      scrollToBottom();
    }, 1500);
  }
}

const resetActivityTimeout = () => {
  count.value = 0;
  clearTimeout(setIntervalDelete.value);
  setIntervalDelete.value = setInterval(() => {
    count.value++;
    switch (count.value) {
      case 45:
        openRelanceModal.value = true;
        relance1.value = true;
        relance2.value = false;
        relance3.value = false;
        break;
      case 90:
        openRelanceModal.value = true;
        relance2.value = true;
        relance1.value = false;
        relance3.value = false;
        break;
      case 420:
        openRelanceModal.value = true;
        relance2.value = false;
        relance1.value = false;
        relance3.value = true;
        clearInterval(setIntervalDelete.value);
        break;
    }
  }, 1000);
};

const lesDeux = async () => {
  switch (currentEnergySelection.value) {
    case 0:
      firstQuestion.value = 'Et vous êtes chez qui pour l\u2019électricité ?';
      suggested_answers.value = [
        { answer: 'ENGIE', answerImg: require('@/assets/logo_engie.png') },
        { answer: 'TOTAL ENERGIES', answerImg: require('@/assets/logo_total.png') },
        { answer: 'PLENITUDE', answerImg: require('@/assets/plenitude.png') },
        { answer: 'EDF', answerImg: require('@/assets/logo_edf.png') },
        { answer: 'SOWEE', answerImg: require('@/assets/logo_sowee.png') },
        { answer: 'AUTRE', answerImg: require('@/assets/logo_autre.png') },
      ];
      currentEnergySelection.value = 1;
      weight.value = 1;
      break;
    case 1:
      firstQuestion.value = 'Et vous êtes chez qui pour le gaz ?';
      suggested_answers.value = [
        { answer: 'ENGIE', answerImg: require('@/assets/logo_engie.png') },
        { answer: 'TOTAL ENERGIES', answerImg: require('@/assets/logo_total.png') },
        { answer: 'PLENITUDE', answerImg: require('@/assets/plenitude.png') },
        { answer: 'EDF', answerImg: require('@/assets/logo_edf.png') },
        { answer: 'SOWEE', answerImg: require('@/assets/logo_sowee.png') },
        { answer: 'AUTRE', answerImg: require('@/assets/logo_autre.png') },
      ];
      break;
  }
}

const secondAgreement = ref(false)
const partenairesList = [
  'ENGIE',
  'Plenitude',
  'Vattenfall',
  'Total Energie',
  'EDF',
  'Alpiq',
  'ILEK',
  'Filiales du groupe VIPP auquel appartient VIPP DATA'
]
const activePartenairesTooltip = ref(null)
const showAucuneOffreModal = ref(false)

const retryConversation = () => {
  showAucuneOffreModal.value = false
  window.location.reload()
}

window.addEventListener('mousemove', resetActivityTimeout);
window.addEventListener('keydown', resetActivityTimeout);

</script>



<style src="./style.css"></style>

<style src="./style.css"></style>
